// src/pages/DBCWebinar.tsx
import React from "react";
import { useInitializePaymentMutation } from "../../../app/api/dBCApi";
import WebinarPage, { handleInitializeResponseRedirect } from "../../../components/common/WebinarPage";

// ── Video ─────────────────────────────────────────────────────────────────────
const EMBED_ID = "KxeXZXfJfok";

// ── Pricing ───────────────────────────────────────────────────────────────────
const FULL_PRICE   = 49999;
const SPLIT_FIRST  = 24999;
const SPLIT_SECOND = 25000;

// ── Trigger ───────────────────────────────────────────────────────────────────
const PAYMENT_TRIGGER_SECONDS = 300; // 5 minutes

// ── Features ──────────────────────────────────────────────────────────────────
const FEATURES = [
  "4-week intensive practical training",
  "3 months ongoing support (community + resources)",
  "Bi-weekly coaching calls (twice per month) for 3 months",
  "Live Q&A sessions every week during the 4-week program",
  "Private WhatsApp/Telegram community",
  "Downloadable worksheets and templates",
  "Lifetime access to core course materials",
  "Free updates and new content",
  "30-day money-back guarantee",
];

// ─────────────────────────────────────────────────────────────────────────────
const DBCWebinar: React.FC = () => {
  const [initializePaymentMutation] = useInitializePaymentMutation();

  /**
   * Matches the InitializePaymentFn signature expected by WebinarPage.
   * Calls the RTK Query mutation, unwraps the result, then redirects to
   * the Paystack authorization URL exactly as the original DBCWebinar did.
   */
  const initializePayment = async (payload: {
    email: string;
    name: string;
    amount: number;
    paymentPlan: "full" | "split";
    metadata?: Record<string, any>;
  }) => {
    const res = await initializePaymentMutation(payload).unwrap();

    const redirected = handleInitializeResponseRedirect(res);
    if (!redirected) {
      alert(
        (res as any)?.message ??
          "Payment initialized but authorization URL wasn't returned. Please contact support.",
      );
    }

    return res;
  };

  return (
    <WebinarPage
      embedId={EMBED_ID}
      initializePayment={initializePayment}
      fullPrice={FULL_PRICE}
      splitFirst={SPLIT_FIRST}
      splitSecond={SPLIT_SECOND}
      features={FEATURES}
      paymentTriggerSeconds={PAYMENT_TRIGGER_SECONDS}
      courseName="Digital Income Accelerator"
      sourceTag="webinar_5min"
    />
  );
};

export default DBCWebinar;